export default __webpack_public_path__ + "static/manual-icon-2f0cad0855c324042774d23723514269.svg";